export const privatePages = [
  {
    page: "Home",
    navigation: "/",
  },
  {
    page: "Blog",
    navigation: "/blog",
  },
  {
    page: "About us",
    navigation: "/about",
  },
  {
    page: "My Journal",
    navigation: "/my-journal",
  },
  {
    page: "Create",
    navigation: "/create",
  },
  {
    page: "Logout",
    navigation: "/logout",
  },
];

export const publicPages = [
  {
    page: "Home",
    navigation: "/",
  },
  {
    page: "Blog",
    navigation: "/blog",
  },
  {
    page: "About us",
    navigation: "/about",
  }
];
